import React, { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import apiClient from '../api/client';
import './Auth.css';

export default function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userId, email } = location.state || {};

  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      await apiClient.post('/auth/verify-email', { userId, code });
      setSuccess('Email verified! Redirecting to login…');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Verification failed');
    } finally {
      setBusy(false);
    }
  }

  if (!userId) {
    return (
      <div className="auth-page">
        <div className="card auth-card">
          <h1>Verification link expired</h1>
          <p className="auth-subtitle">Please register again or log in.</p>
          <Link to="/register" className="btn btn-primary">Back to registration</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <div className="card auth-card">
        <h1>Check your email</h1>
        <p className="auth-subtitle">We sent a 6-digit code to {email}.</p>

        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-field">
            <label htmlFor="code">Verification code</label>
            <input id="code" required value={code} onChange={(e) => setCode(e.target.value)} />
          </div>
          <button className="btn btn-primary" disabled={busy}>{busy ? 'Verifying…' : 'Verify email'}</button>
        </form>
      </div>
    </div>
  );
}
